import { ERRORS } from "@/services/api";
import { notifier } from '@/shared/lib/notifier/index';

export const DataBacked = {
    methods: {
      onDataError(err) {
        // eslint-disable-next-line
        console.error(err);
        if (err.code === ERRORS.AUTH) {
          this.$store.commit("setToken", "");
          if (this.$route && this.$route.go) {
            this.$route.go();
          } else {
            document.location.reload();
          }
        } else {
          if (err.message && err.message.details)
            notifier.showError(err.message.details.substring(0, 1000));
          else if (err.message && err.message.substring)
            notifier.showError(err.message.substring(0, 1000));
        }
      }
    },
}